/**
 * Utility function to clean and sanitize HTML content
 * @param {string} html - The HTML content to clean
 * @returns {string} - The cleaned HTML content
 */
export const cleanHtmlContent = (html) => {
    if (!html) return ''
    
    let cleaned = html
    
    // Look for URL-encoded sections that contain HTML tags and decode them
    // We'll find sections that have %XX encoding followed by HTML tags
    if (html.includes('%')) {
        // Find all URL-encoded segments in the content
        const urlEncodedPattern = /%[0-9A-Fa-f]{2}/g
        const hasEncodedContent = urlEncodedPattern.test(html)
        
        if (hasEncodedContent) {
            try {
                // Decode the entire content
                cleaned = decodeURIComponent(html)
            } catch (error) {
                console.warn('Failed to decode entire URI component, trying partial decoding:', error)
                // If full decoding fails, try to decode only specific segments
                try {
                    // Replace all %XX sequences with their decoded characters
                    cleaned = html.replace(urlEncodedPattern, (match) => {
                        return String.fromCharCode(parseInt(match.slice(1), 16))
                    })
                } catch (partialError) {
                    console.warn('Failed to decode URI segments, using original content:', partialError)
                    // If all decoding fails, use the original content
                    cleaned = html
                }
            }
        }
    }
    
    // Remove any duplicate HTML tags (like double DOCTYPE declarations)
    // This specifically handles the case where we have both plain and encoded HTML
    cleaned = cleaned.replace(/<!DOCTYPE html>[\s\S]*?<!DOCTYPE html>/i, '<!DOCTYPE html>')
    
    // Remove markdown code block markers
    cleaned = cleaned.replace(/```html/g, '').replace(/```/g, '')
    
    // Remove any surrounding quotes if present
    cleaned = cleaned.replace(/^["']|["']$/g, '')
    
    // Remove any double escaping of HTML entities
    cleaned = cleaned.replace(/&/g, '&')
    cleaned = cleaned.replace(/</g, '<')
    cleaned = cleaned.replace(/>/g, '>')
    cleaned = cleaned.replace(/"/g, '"')
    cleaned = cleaned.replace(/&#39;/g, "'")
    
    // Remove any extra whitespace
    cleaned = cleaned.trim()
    
    return cleaned
}
